
































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditThreshold from "./edit-outairthreshold.vue";
import CreateThreshold from "./create-outairthreshold.vue";
class PageThresholdRequest extends PageRequest {
  FilterText: string;
}
@Component({
  components: { EditThreshold, CreateThreshold },
})
export default class Floors extends AbpBase {
  pagerequest: PageThresholdRequest = new PageThresholdRequest();
  publicpagerequest: PageThresholdRequest = new PageThresholdRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get list() {
    return this.$store.state.outair_threshold.list;
  }
  get loading() {
    return this.$store.state.outair_threshold.loading;
  }
  pageChange(page: number) {
    this.$store.commit("outair_threshold/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("outair_threshold/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    await this.$store.dispatch({
      type: "outair_threshold/getAll",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.outair_threshold.pageSize;
  }
  get totalCount() {
    return this.$store.state.outair_threshold.totalCount;
  }
  get currentPage() {
    return this.$store.state.outair_threshold.currentPage;
  }
    userName() {
    //console.log(this.$store.state.session.user);
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
    companylist() {
     
    return this.$store.state.company.list;
  }
  columns = [
     {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "阈值方案",
      key: "tName",
    },
    {
      title: "最小温度（℃）",
      key: "mintemp",
    },
    {
      title: "最大温度（℃）",
      key: "maxtemp",
    },
    {
      title: "最大湿度（%）",
      key: "minhumi",
    },
     {
      title: "PM2.5",
      key: "maxpM25",
    },
    {
      title: "PM10",
      key: "maxpM10",
    },
    {
      title: "VOC挥发物",
      key: "maxvoc",
    },
    {
      title: "风速",
      key: "maXwind_speed",
    },
    {
      title: "噪音",
      key: "maXnoise",
    },
    {
      title: "大气压",
      key: "maXpressure",
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("outair_threshold/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "outair_threshold/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];
   async getcompany() {
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
      data: this.publicpagerequest,
    });
  }
  created() {
      this.publicpagerequest.maxResultCount = 99;
    this.publicpagerequest.skipCount = 0;
     if (this.userName() !== "admin") {
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }else{
      this.getcompany();
    }
    this.getpage();
  }
}
